"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var react_1 = __importDefault(require("react"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Switch_1 = __importDefault(require("@material-ui/core/Switch"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var styles_1 = require("./styles");
var useStyles = (0, system_1.makeStyles)(function (theme) {
    return {
        switchClass: {
            width: 40,
            height: 24,
            padding: 0,
            borderRadius: 12,
            border: 'none !important',
        },
        checked: {
            '$switchClass &': {
                color: 'inherit !important',
                transform: 'translateX(16px)',
            },
        },
        thumb: {
            boxShadow: 'none',
            color: 'inherit !important',
        },
        switchBase: {
            padding: 2,
            color: 'inherit !important',
        },
        track: {
            '$switchClass &, $switchClass $checked + &': {
                backgroundColor: "".concat(theme.go.schemes.colors.system.ControlMinor, " !important"),
                opacity: 1,
                transition: 'none',
            },
            '$switchClass $checked + &': {
                backgroundColor: "".concat(theme.go.schemes.colors.system.ControlMain, " !important"),
            },
        },
    };
});
exports.Switch = react_1.default.memo(function (_a) {
    var className = _a.className, label = _a.label, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? 'end' : _b, props = __rest(_a, ["className", "label", "labelPlacement"]);
    var _c = (0, styles_1.useBaseStyles)({
        labelPlacement: label ? labelPlacement : undefined,
    }), go = _c.go, labelRoot = _c.labelRoot, labelDisabled = _c.labelDisabled, disabled = _c.disabled, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    indeterminate = _c.indeterminate, labelText = _c.labelText, classes = __rest(_c, ["go", "labelRoot", "labelDisabled", "disabled", "indeterminate", "labelText"]);
    var _d = useStyles(), switchClass = _d.switchClass, switchClasses = __rest(_d, ["switchClass"]);
    var SwitchEl = (react_1.default.createElement(Switch_1.default, __assign({}, props, { className: (0, utils_1.cn)(className, go, switchClass, props.disabled ? disabled : undefined), classes: __assign(__assign({}, classes), switchClasses) })));
    if (!label) {
        return SwitchEl;
    }
    return (react_1.default.createElement(FormControlLabel_1.default, { className: go, classes: {
            root: labelRoot,
            disabled: labelDisabled,
            label: labelText,
        }, control: SwitchEl, label: label, labelPlacement: labelPlacement }));
});
